// i18n
import { useTranslation } from 'react-i18next';

// types
import { CountryCode, Entity, Metadata } from '../../../../../@types';
import { countryCodes } from '../../../../../@types/unions';

// mui
import { Grid, Typography, Paper } from '@mui/material';
import { Flag } from '../../../../ui/Flag/Flag';

// ui
import { IconCircle } from '../../../../ui/IconCircle/IconCircle';

// props
export interface CardLocationProps {
	entity: Entity;
}

export const CardLocation = ({ entity }: CardLocationProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	const entityMetadata = (entity.metadata ?? {}) as Metadata;
	const isValidCountry = countryCodes.includes(entityMetadata.country as CountryCode);

	let countryName = '';

	if (isValidCountry) {
		const spacer = entityMetadata.city ? ', ' : '';
		countryName = `${spacer}${new Intl.DisplayNames(['en'], { type: 'region' }).of(
			String(entityMetadata.country)
		)}`;
	}

	let address = entityMetadata.address1;

	if (entityMetadata.address2) {
		address += `, ${entityMetadata.address2}`;
	}
	if (entityMetadata.postcode) {
		address += `, ${entityMetadata.postcode}`;
	}

	return (
		<Paper
			sx={(theme) => {
				return {
					padding: theme.spacing(2),
					height: '100%',
				};
			}}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography variant="h3">{t('location')}</Typography>
				</Grid>
				<Grid item xs={12}>
					<Grid container spacing={1}>
						<Grid item xs={12}>
							<Grid alignItems="center" container spacing={1}>
								{isValidCountry ? (
									<Grid item>
										<Flag code={entityMetadata.country as CountryCode} />
									</Grid>
								) : (
									<Grid item>
										<IconCircle color="magenta" size="xs" type="local" />
									</Grid>
								)}
								<Grid flex={1} item>
									<Typography>
										{entityMetadata.city}
										{countryName}
									</Typography>
								</Grid>
							</Grid>
						</Grid>
						{address && (
							<Grid item xs={12}>
								<Grid alignItems="center" container spacing={1}>
									<Grid item>
										<IconCircle size="xs" type="location" />
									</Grid>
									<Grid flex={1} item>
										<Typography>{address}</Typography>
									</Grid>
								</Grid>
							</Grid>
						)}
					</Grid>
				</Grid>
			</Grid>
		</Paper>
	);
};
